import React from 'react';
import styled from 'styled-components';
import Header from '../../components/common/header/Header';
import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Redirect, useHistory } from 'react-router-dom';
import { reqEsOrderInfoAction, reqEsOrderCodeReset } from '../../modules/od/orderModule';
import { setCurMenuAction, setHeaderTransferAction } from '../../modules/common/headerModule';
import Footer from '../../components/common/Footer';
import { useState } from 'react';
import EsOrderDonePayinfo from '../../components/es/EsOrderDonePayinfo';
import EsOrderDoneDvryInfo from '../../components/es/EsOrderDoneDvryInfo';
import EsOrderDoneProdInfo from '../../components/es/EsOrderDoneProdInfo';

const EsOrderDoneBlock = styled.div`
    width: 100%;
    margin: 0 auto;
`;

const EsOrderDoneContentsBlock = styled.div`
    padding: 60px 0 120px
`;

/**
 * 주문완료 페이지 
 * @param {*} param0 
 */
const EsOrderDone = ({ location }) => {

    const dispatch = useDispatch();
    const history = useHistory();

    const [reqCnt, setReqCnt] = useState(0);


    const { esOrderInfo, accessToken, curMenu, error } = useSelector(
        ({ userReducer, esOrderReducer, headerReducer }) => ({
            accessToken: userReducer.accessToken,
            esOrderInfo: esOrderReducer.esOrderInfo,
            curMenu: headerReducer.curMenu,
            error: esOrderReducer.error
        })
    );

    useEffect(() => {

        if (curMenu !== 'oddone') {
            dispatch(setCurMenuAction('oddone'));
            dispatch(setHeaderTransferAction(false));
            window.scrollTo(0, 0);
        }

        if (accessToken === null || location.search === null
            || location.search === undefined) {
            history.push("/notfound");
        }
    });

    useEffect(() => {

        if (error !== null) {
            // TODO : 오류 발생시 에는 오류 페이지 표시 
            dispatch(reqEsOrderCodeReset());
            history.push("/");
        } else if ((esOrderInfo !== null && esOrderInfo.code === 600)) {
            dispatch(reqEsOrderCodeReset());
            history.push("/");
        } else if (esOrderInfo === null && reqCnt < 5) {
            setReqCnt(reqCnt + 1);
            dispatch(reqEsOrderInfoAction(location.search));
        }

    }, [esOrderInfo, error])

    if (accessToken === null || (esOrderInfo !== null && esOrderInfo.code === 600)) {
        dispatch(reqEsOrderCodeReset());
        return <Redirect to="/" />
    }

    if (esOrderInfo === null) {
        return <EsOrderDoneBlock />
    }



    const isVbank = () => {
        return (esOrderInfo.data.orderinfo.od_pay_type_code === '150402');
    }

    return (
        <EsOrderDoneBlock>
            <Header />
            <EsOrderDoneContentsBlock>
                <div className="small-section">
                    <div className="sz-wrap">
                        <div className="pay-title clearfix" style={{ margin: '90px 0 50px' }} >
                            <h2 className="f-left">주문 완료</h2>
                        </div>

                        <div className="es_title-box margin_t-20  margin_b-50">
                            <h3 className="es_title_sub margin_b-16">{esOrderInfo.data.orderinfo.pckg_nm}</h3>
                            <p className="payment_done-title"><span>주문이 완료</span>되었습니다.</p>
                            <p style={{ display: isVbank() ? 'block' : 'none' }}>
                                선택하신 은행으로 입금해주시길 바랍니다.
                            </p>

                            <p className="es_date gray margin_t-30">
                                <span>주문 일자 : <span>{esOrderInfo.data.orderinfo.od_reg_date}</span></span>
                                <span className="d-inline margin_l-15">주문 번호 : <span>{esOrderInfo.data.orderinfo.od_id}</span></span>
                            </p>
                        </div>

                        <EsOrderDonePayinfo esOrderInfo={esOrderInfo} />

                        <EsOrderDoneDvryInfo esOrderInfo={esOrderInfo} />

                        <EsOrderDoneProdInfo esOrderInfo={esOrderInfo} />

                    </div>

                    <div className="pay_done_btn-wrap">
                        <a href="/" className="mh-btn gray-btn">홈 이동</a>
                        <a href="/es" className="mh-btn black-btn margin_l-30">가구 견적 이동</a>
                    </div>
                </div>
            </EsOrderDoneContentsBlock >
            <Footer />
        </EsOrderDoneBlock >
    );
};

export default EsOrderDone;